import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsLeftDownSizeS from './IconToolsLeftDown_size_s';

const props: CreateIconArguments = {
  l: IconToolsLeftDownSizeS,
  m: IconToolsLeftDownSizeS,
  s: IconToolsLeftDownSizeS,
  xs: IconToolsLeftDownSizeS,
  name: 'IconToolsLeftDown',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
